import { Box } from "@mui/material";
import React from "react";

/**
 * MUI-styled tab panel component that shows content only when the tab is selected
 *
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Content to display when panel is active
 * @param {string|number} props.value - Current selected tab value
 * @param {string|number} props.index - This panel's index/value
 * @returns {JSX.Element} Tab panel component
 */
function TabPanel({ children, value, index, ...other }) {
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      sx={{ pt: 3 }}
      {...other}
    >
      {value === index && children}
    </Box>
  );
}

export default TabPanel;
